module.exports = __webpack_public_path__ + "img/pic_button_start@2x.fb9f31c7.png";